// import { Component } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DateRangePayload, FilterDateRangeService } from 'src/app/services/filterdaterange.service';



export interface FilterState {
  deliveryStatus: string[];
  orderRange: { start: Date | null; end: Date | null };
  products: string[];
}

@Component({
  selector: 'app-filter-side-nav',
  templateUrl: './filter-side-nav.component.html',
  styleUrl: './filter-side-nav.component.scss'
})
export class FilterSideNavComponent {
  @Output() filtersApplied = new EventEmitter<FilterState>();
  @Output() filtersCleared = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  @Output() rangeSelected = new EventEmitter<DateRangePayload>();
    
   private currentViewSubject = new BehaviorSubject<string>('filter-side-nav');
   currentView$ = this.currentViewSubject.asObservable();
   currentView: string = 'filter-side-nav';
   

  constructor(private router: Router, private filterDateRangeService: FilterDateRangeService) {
     this.currentView$.subscribe(view => {
      this.currentView = view;
    });
    
    // Load current dates from service on initialization
    this.loadCurrentDatesFromService();
  }

  isOpen = false;
  
  private filters: FilterState = {
    deliveryStatus: [],
    orderRange: { start: null, end: null },
    products: []
  };

  private loadCurrentDatesFromService(): void {
    // Subscribe to get current date range from service
    this.filterDateRangeService.dateRangeSelected$.subscribe((range) => {
      if (range && range.startDate && range.endDate) {
        // Parse the dates from YYYY-MM-DD format
        const [startYear, startMonth, startDay] = range.startDate.split('-').map(Number);
        const [endYear, endMonth, endDay] = range.endDate.split('-').map(Number);
        
        const startDate = new Date(startYear, startMonth - 1, startDay);
        const endDate = new Date(endYear, endMonth - 1, endDay);
        
        // Update filters with the loaded dates
        this.filters.orderRange = { start: startDate, end: endDate };
        console.log('Loaded dates from service:', { start: startDate, end: endDate });
      }
    });
  }

  open(): void {
    this.isOpen = true;
    this.currentViewSubject.next('filter-side-nav');
  }

  close(): void {
    this.isOpen = false;
    this.closed.emit();
     this.currentViewSubject.next('filter-side-nav');
  }

  toggle(): void {
    this.isOpen ? this.close() : this.open();
  }

  toggleSection(view: string): void {
    if(view == 'order-date-range'){
      this.currentViewSubject.next(view);

    }
    
  }

  applyFilters(): void {
    this.filtersApplied.emit(this.filters);
   this.close();
  }

  clearFilters(): void {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Strip time
    
    const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);
    
    // Update filters with 90-day defaults
    this.filters = {
      deliveryStatus: [],
      orderRange: { start: ninetyDaysAgo, end: today },
      products: []
    };
    
    // Save the 90-day defaults to the service
    const startDateStr = this.toYMD(ninetyDaysAgo);
    const endDateStr = this.toYMD(today);
  
   this.filterDateRangeService.setCustomDateRange(startDateStr, endDateStr);
    this.rangeSelected.emit({ startDate: startDateStr, endDate: endDateStr });
   this.filtersApplied.emit(this.filters);
    
    console.log('Clear filters: Set 90-day defaults', { start: startDateStr, end: endDateStr });
    
    // Keep the sidenav open and emit cleared event
    this.isOpen = false; // Close the sidenav after clearing filters
    this.filtersCleared.emit();
  }

  private toYMD(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  getFilters(): FilterState {
    return { ...this.filters };
  }

  setFilters(filters: Partial<FilterState>): void {
    this.filters = { ...this.filters, ...filters };
  }
  goBackToMain(): void {
    console.log('Going back to main filter');
    this.currentViewSubject.next('filter-side-nav');
    // Keep the sidenav open when navigating back from date range selection
  }

  handleRangeSelection(range: { startDate: string; endDate: string }): void {
    console.log('Handling range selection:', range);
    
    // Update the filters with selected date range
    const startDate = new Date(range.startDate);
    const endDate = new Date(range.endDate);
    console.log('Parsed Start Date:', startDate);
    console.log('Parsed End Date:', endDate);
    
    this.filters.orderRange = { start: startDate, end: endDate };
    this.filterDateRangeService.setCustomDateRange(range.startDate, range.endDate);

    // Emit the range to parent component
    this.rangeSelected.emit({ startDate: range.startDate, endDate: range.endDate });
    
    // Apply filters and close the filter panel
    this.applyFilters();
  }
}